import React, { Component } from 'react';

interface ClickOutsideProps {
    onClickOutside?: () => void;
    children?: React.ReactNode;
}

class ClickOutside extends Component<ClickOutsideProps> {
    static defaultProps = {
        onClickOutside: () => undefined,
        children: null
    };

    WrapperNode: HTMLDivElement | null = null;

    componentDidMount() {
        document.addEventListener('mousedown', this._eventHandler, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this._eventHandler, false);
    }

    _eventHandler = (event: MouseEvent) => {
        if (this.WrapperNode?.contains(event.target as Node)) return;
        this.props.onClickOutside?.();
    };

    render() {
        return (
            <div
                ref={(ref: HTMLDivElement | null) => {
                    this.WrapperNode = ref;
                }}>
                {this.props.children}
            </div>
        );
    }
}

export default ClickOutside;
